import axios from "axios";
/* eslint-disable */

export default () => 
{ 
  // const data = { baseURL: "https://agrisoo9-api.um6p.ma/api/" };
  // eslint-disable-next-line
  const data = { baseURL:"https://agriedgeapi.com/v2"}
  return axios.create(data);
 
};
 